export default {
  'app.true': 'はい',
  'app.false': 'いいえ',
  'app.403.page': '権限がありません',
  'app.403.page.tip': '管理者に権限を申請してください',
};
